export let isDialogOpen = false;
export const setDialogOpen = (val: boolean) => {
  isDialogOpen = val;
};
